import React from "react";

interface Tab {
  id: string;
  label: string;
  disabled?: boolean;
  badge?: number;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (tabId: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  setActiveTab,
  className = "",
}) => {
  return (
    <div className={className}>
      <div className="border-b border-gray-200">
        <nav
          className="-mb-px flex space-x-8 overflow-x-auto scrollbar-hide"
          aria-label="Tabs"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => !tab.disabled && setActiveTab(tab.id)}
              disabled={tab.disabled}
              className={[
                activeTab === tab.id
                  ? "border-primary-500 text-primary-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                tab.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer",
                "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center min-h-[44px] sm:min-h-0",
              ].join(" ")}
              aria-current={activeTab === tab.id ? "page" : undefined}
            >
              {tab.label}
              {tab.badge !== undefined && (
                <span
                  className={`ml-2 py-0.5 px-2 rounded-full text-xs ${
                    activeTab === tab.id
                      ? "bg-primary-100 text-primary-600"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {tab.badge}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Tabs;
